import React from 'react';

const VerificationComplete = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 text-center">
      <h2 className="text-2xl font-bold mb-4">Application Received</h2>
      <p className="mb-2">
        We have received your application and documentation.
      </p>
      <p className="mb-2">
        We have sent the KYC link to directors and shareholders. Please complete the KYC.
      </p>
      <p>
        Our compliance team will review your application and approve it.
      </p>
    </div>
  );
};

export default VerificationComplete;
